<template>
  <div class="apple-new-releases" :aria-busy="String(loading)">
    <div class="apple-new-releases-heading"><h2>新专辑</h2><div v-if="platform !== 'tx'" class="apple-new-area" role="group" aria-label="新专辑地区" @keydown="moveArea"><button v-for="item in areas" :key="item.key" type="button" :data-album-area="item.key" :aria-pressed="String(area === item.key)" @click="selectArea(item.key)">{{ item.value }}</button></div></div>
    <div class="apple-new-album-grid"><article v-for="item in visibleAlbums" :key="String(item.id)" class="apple-new-album"><div class="apple-new-album-artwork"><Cover :id="item.id" :label="item.name" type="album" :image-url="albumArtwork(item)" :cover-hover="false" :always-show-play-button="true" :play-button-size="18" :radius="6" /></div><router-link class="apple-new-album-title" :to="{name:'album',params:{id:String(item.id)}}" :title="item.name">{{ item.name }}</router-link><span v-if="albumArtists(item)" class="apple-new-album-artist" :title="albumArtists(item)">{{ albumArtists(item) }}</span><time v-if="albumDate(item)" :datetime="albumDate(item, true)">{{ albumDate(item) }}</time></article></div>
    <AppleState :loading="loading" :error="error" :more="more" :count="visibleAlbums.length" empty-text="来源暂未返回新专辑。" @retry="loadFeed(visibleAlbums.length > 0)" @more="loadFeed(true)" />
  </div>
</template>
<script>
import DiscoverNew from '../salt/online/DiscoverNew.vue';
import Cover from '../components/Cover.vue';
import AppleState from './ui/AppleState.vue';
import { runtime } from '../bridge';
import { releaseDate } from './search-entity-metadata';
import './apple-discover-new.scss';
export default {
  name: 'AppleDiscoverNew', extends: DiscoverNew, components: { Cover, AppleState },
  data() { return { runtime }; },
  computed: {
    visibleAlbums() {
      return (Array.isArray(this.items) ? this.items : []).filter(item => item && ['string', 'number'].includes(typeof item.id) && String(item.id).trim() !== '' && typeof item.name === 'string' && item.name.trim() !== '');
    },
  },
  methods: {
    moveArea(event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const buttons = [...event.currentTarget.querySelectorAll('button[data-album-area]')];
      const index = buttons.indexOf(event.target);
      if (index < 0) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
      buttons[next].focus();
      this.selectArea(buttons[next].dataset.albumArea);
    },
    albumArtwork(album) {
      for (const value of [album.picUrl, album.coverImgUrl, album.cover]) if (typeof value === 'string' && value.trim()) return value;
      return runtime.cover();
    },
    albumArtists(album) {
      const list = Array.isArray(album.artists) ? album.artists : album.artist ? [album.artist] : [];
      return list.map(artist => typeof artist === 'string' ? artist : artist && typeof artist.name === 'string' ? artist.name : '')
        .map(name => name.trim()).filter(Boolean).join(' / ');
    },
    albumDate(album, machine = false) {
      const date = releaseDate(album);
      return machine ? date : date.replaceAll('-', '.');
    },
    async fetchFeed(cursor) {
      const result = await runtime.catalog('albums', undefined, { platform: this.platform, area: this.platform === 'tx' ? 'ALL' : this.area, offset: cursor, limit: 50 });
      const items = Array.isArray(result.albums) ? result.albums.filter(item => item && ['string', 'number'].includes(typeof item.id) && String(item.id).trim() !== '' && typeof item.name === 'string' && item.name.trim() !== '') : [];
      return { items, more: result.more, nextCursor: result.nextCursor };
    },
  },
};
</script>
